/// <reference path='../../interfaces/interfaces.d.ts' />

import {IStateService} from 'angular-ui-router';

'use strict';

class CalendarService implements ICalendarService {
    public static $inject = [
        '$state',
        '$q',
        'Api',
        'Orgs',
        'User'
    ];

    public org


    constructor(private $state: IStateService,
                private $q: any,
                private Api: any,
                private Org: IOrgsService,
                private User: IUserService) {
                  var that: any = this
                  if (User.getCurrentUser().isSuperUser) {
                    return
                  }

                  Org.getMyOrg().then(org => {
                    if (!org.extra.details) {
                        org.extra.details = {}
                    }
                    if (!org.extra.benefits) {
                        org.extra.benefits = []
                    }
                    if (!org.extra.offices) {
                        org.extra.offices = []
                    }
                    if (!org.extra.processes) {
                        org.extra.processes = {}
                    }
                    that.org = org
                  })
    }

    private eventTypes = [
        'Business Travel',
        'Work Event',
        'Personal Event',
        'HR Appointment',
        'Performance Review',
        'Training',
        'Conference',
        'Recruitment',
        'Industry specific leave',
        'Other'
    ];

    private eventTypeIcons: any = {
        'Business Travel': 'flight_takeoff',
        'Work Event': 'work',
        'Personal Event': 'person',
        'HR Appointment': 'insert_invitation',
        'Performance Review': 'trending_up',
        'Training': 'library_books',
        'Conference': 'people',
        'Recruitment': 'record_voice_over',
        'Industry specific leave': 'build',
        'Other': 'grade'
    };

    private repeatCases = {
        none: {
            name: 'None',
            value: undefined
        },
        daily: {
            name: 'Daily',
            value: 'daily'
        },
        weekly: {
            name: 'Weekly',
            value: 'weekly'
        },
        monthly: {
            name: 'Monthly',
            value: 'monthly'
        },
        yearly: {
            name: 'Yearly',
            value: 'yearly'
        }
    };


    public getRepeatCases(): any {
        return this.repeatCases;
    }

    public loadEvents = (start: number, end: number, calendar_type: string = '', show_leave: boolean = true) => {
        let calendar: Restangular.IElement;
        if (this.$state.current.name === 'root.employees.details.calendar') {
            calendar = this.Api.one('employees', this.$state.params['id']).one('calendar');
        } else {
            calendar = this.Api.one('calendar');
        }
        return calendar.get({ start: start, end: end, calendar_type: calendar_type, show_leave: show_leave });
    };

    public loadEvent(eventId: number): any {
        return this.Api.one('events', eventId).get();
    }

    public loadHoliday(holidayId: number): any {
      var holidays = _.get(this.org.extra, 'leave.holidays', [])
      var holiday = {}
      holidays.map(_holiday => {
        if(_holiday.id == holidayId){
          holiday = _holiday;
        }
      })
      return this.$q.resolve(holiday);
    }

    public createEvent = (event: IEvent) => {
        // Extract event start and end items. These should be normal JS dates, which we'll convert to moments
        let startDateTime = moment(event.start).utcOffset(moment().utcOffset()).utc();
        let endDateTime =  moment(event.end).utcOffset(moment().utcOffset()).utc();

        let event_type = event.event_type == "Other" ? event.event_type_custom : `${event.event_type}`
        let newEvent: any = {
            title:  `${event_type}: ${event.title}`, // crutch
            start:  startDateTime,
            end:    endDateTime,
            // start:  moment.isMoment(event.start) ? event.start.utcOffset(moment().utcOffset()).utc() : undefined,
            // end:    moment.isMoment(event.end) ? event.end.utcOffset(moment().utcOffset()).utc() : undefined,
            calendar: this.makeEventOwner(event.calendar_type),
            rule:   this.repeatCases[event.rule] ? event.rule : undefined,
            description: event.description,
            end_recurring_period: event.end_recurring_period
        };
        return this.Api.restangularizeElement(undefined, newEvent, 'events').save();
    };

    public createHoliday = (event: IEvent) => {
      var holidays = _.get(this.org.extra, 'leave.holidays', [])
      var maxid = 0;
      holidays.map(function(obj){
          if (obj.id > maxid) maxid = obj.id;
      });
      holidays.push({
          id: maxid+1,
          title: event.title,
          start_date: event.start.format('YYYY[-]MM[-]DD'),
          end_date: event.end.format('YYYY[-]MM[-]DD'),
          description: event.description
      })
      jQuery.extend(true, this.org.extra,
        {leave: {holidays: holidays}})

      return this.org.put()
    }

    public updateEvent = (event: IEvent) => {
        let event_type = event.event_type == "Other" ? event.event_type_custom : `${event.event_type}`
        let newEvent: any = {
            id:     event.id,
            title:  `${event_type}: ${event.title}`, // crutch
            start:  moment.isMoment(event.start) ? event.start.utcOffset(moment().utcOffset()).utc() : undefined,
            end:    moment.isMoment(event.end) ? event.end.utcOffset(moment().utcOffset()).utc() : undefined,
            calendar: this.makeEventOwner(event.calendar_type),
            rule: event.rule,
            description: event.description,
            end_recurring_period: event.end_recurring_period
        };
        return this.Api.restangularizeElement(undefined, newEvent, 'events').put();
    }

    public updateHoliday = (Holiday: IEvent) => {
      var holidays = _.get(this.org.extra, 'leave.holidays', [])
      var holidays_after_delete = []
      holidays.map(holiday => {
        if(holiday.id !== Holiday.id){
          holidays_after_delete.push(holiday);
        }else{
          Holiday.startDate = new Date(holiday.start_date)
          Holiday.endDate = new Date(holiday.end_date)
        }
      })

      // If updateHolidays is being called from edit-modal-event
      // controller then Holiday.end is null so need to set
      // it to Holiday.endDate
      if(!Holiday.end)
      {
        Holiday.end = moment(Holiday.endDate)
      }

      this.org.extra.leave.holidays = holidays_after_delete
      this.org.extra.leave.holidays.push({
          id: Holiday.id,
          title: Holiday.title,
          start_date: Holiday.start.toISOString().slice(0,10),
          end_date: Holiday.end.toISOString().slice(0,10),
          description: Holiday.description
      })
      return this.org.put()
    }

    public removeEvent(eventId: number): Restangular.IPromise<any> {
        return this.Api.one('events', eventId).remove();
    };

    public removeHoliday(holidayId: number){
          var holidays = _.get(this.org.extra, 'leave.holidays', [])
          var holidays_after_delete = []
          holidays.map(holiday => {
            if(holiday.id !== holidayId){
              holidays_after_delete.push(holiday);
            }
          })
          this.org.extra.leave.holidays = holidays_after_delete
          return this.org.put()
    }

    public parseCalendarType = (type: string) => {
        let dashPos: number = type.indexOf('_');
        if (dashPos !== -1) {
            return type.substr(dashPos + 1);
        } else {
            return '';
        }
    };

    public getEventTypes(): string[] {
        return this.eventTypes;
    }

    public getEventTypeIcons(): any {
        return this.eventTypeIcons;
    }

    public makeTitle(event): void {
        //== Crutch start
        let parsedTitle = event.title.split(': ');
        if (parsedTitle.length === 2) {
            event.event_type = parsedTitle[0];
            event.title = parsedTitle[1];
        }
        //== Crutch end
    }

    public getTodayCountEvents(fn) {
        this.loadEvents(moment().startOf('day').unix(), moment().endOf('day').unix()).then((response) => {
            let event_count = response.length;
            // Remove leave events from count
            for (let i=0; i < response.length; i++) {
                if (response[i].calendar_type === 'leaves') {
                    event_count -= 1;
                }
            }
            (fn || angular.noop)(event_count);
        }, () => {
            (fn || angular.noop)(0);
        })
    }

    private makeEventOwner(calendar_type: string): string {
        return (this.$state.current.name.indexOf('employees.details.calendar') !== -1)
            ? `${this.$state.params['id']}_${calendar_type}`
            : `${this.User.getUserId()}_${calendar_type}`;
    }

    public getListEvents(start: number, end: number, calender_type: string): any {
        /**
         *  TODO:
         *  * check the date value from the api vs the schema form. 
         *  * Note the Color has been removed thus we have to make provision for the leave_type object.
         *  *just a note on the leave type. Since we dont have all the elements being leave maybe use a find and replace and change it 
         *      to event_type rather than leave type. // already changed it.
         *  
         */
        let calenderObjArr: any = [ {
                description: '',
                calendar_type: 'self',
                created_on: '2018-10-21T18:00:00Z',
                end_recurring_period: undefined,
                end: '2018-10-21T18:15:00.000Z',
                title: 'Recruitment: Recru Testing',
                event_id: 12,
                rule: 'None',
                start: '2018-10-21T18:00:00.000Z',
                employee_id: '51a155c0-9ded-4f57-9e3b-934a25e7ba75',
                employee_full_name: '',
                event_type: 'recruitment' 
            },   {
                description: '',
                calendar_type: 'self',
                created_on: '2018-10-20T18:00:00Z',
                end_recurring_period: undefined,
                end: '2018-10-20T18:15:00.000Z',
                title: 'Conference: Conference',
                event_id: 11,
                rule: 'None',
                start: '2018-10-20T18:00:00.000Z',
                employee: '51a155c0-9ded-4f57-9e3b-934a25e7ba75',
                employee_full_name: '',
                event_type: 'conference'
            },
            {
                description: '',
                calendar_type: 'self',
                created_on: '2018-10-17T18:00:00Z',
                end_recurring_period: undefined,
                end: '2018-10-17T18:15:00.000Z',
                title: 'HR Appointment: hr testing',
                event_id: 8,
                rule: 'None',
                start: '2018-10-17T18:00:00.000Z',
                employee: '51a155c0-9ded-4f57-9e3b-934a25e7ba75',
                employee_full_name: '',
                event_type: 'hr-appointment'
              },
              {
                description: '',
                calendar_type: 'self',
                created_on: '2018-10-16T18:00:00Z',
                end_recurring_period: undefined,
                end: '2018-10-16T18:15:00.000Z',
                title: 'Personal Event: Personal Testing',
                event_id: 7,
                rule: 'None',
                start: '2018-10-16T18:00:00.000Z',
                employee: '51a155c0-9ded-4f57-9e3b-934a25e7ba75',
                employee_full_name: '',
                event_type: 'personal-event'
              },
              {
                description: '',
                calendar_type: 'direct_subordinates',
                created_on: '2018-10-22T18:00:00Z',
                end_recurring_period: undefined,
                end: '2018-10-22T18:15:00.000Z',
                title: 'Industry specific leave: Indust SPec',
                event_id: 13,
                rule: 'None',
                start: '2018-10-22T18:00:00.000Z',
                employee: '51a155c0-9ded-4f57-9e3b-934a25e7ba75',
                employee_full_name: '',
                event_type: 'industry-leave'
              },
              {
                description: '',
                calendar_type: 'direct_subordinates',
                created_on: '2018-10-18T18:00:00Z',
                end_recurring_period: undefined,
                end: '2018-10-18T18:15:00.000Z',
                title: 'Performance Review: Perf Review Testing',
                event_id: 9,
                rule: 'None',
                start: '2018-10-18T18:00:00.000Z',
                employee: '51a155c0-9ded-4f57-9e3b-934a25e7ba75',
                employee_full_name: '',
                event_type: 'preformance-review'
              },
              {
                calendar_type: 'direct_subordinates',
                created_on: '2018-10-11T14:00:00Z',
                end_recurring_period: '2018-10-14T22:00:00Z',
                end: '2018-10-11T14:15:00.000Z',
                title: 'Work Event: xzdfsdfg',
                event_id: 4,
                rule: 'Rule daily params None',
                start: '2018-10-11T14:00:00.000Z',
                employee: '51a155c0-9ded-4f57-9e3b-934a25e7ba75',
                employee_full_name: '',
                event_type: 'work-event'
              },
              {
                description: '',
                calendar_type: 'direct_subordinates',
                created_on: '2018-10-11T14:00:00Z',
                end_recurring_period: '2018-10-14T22:00:00Z',
                end: '2018-10-12T14:15:00.000Z',
                title: 'Work Event: xzdfsdfg',
                event_id: 4,
                rule: 'Rule daily params None',
                start: '2018-10-12T14:00:00.000Z',
                employee: '51a155c0-9ded-4f57-9e3b-934a25e7ba75',
                employee_full_name: '',
                event_type: 'work-event'
              },
              {
                description: '',
                calendar_type: 'direct_subordinates',
                created_on: '2018-10-11T14:00:00Z',
                end_recurring_period: '2018-10-14T22:00:00Z',
                end: '2018-10-13T14:15:00.000Z',
                title: 'Work Event: xzdfsdfg',
                event_id: 4,
                rule: 'Rule daily params None',
                start: '2018-10-13T14:00:00.000Z',
                employee: '51a155c0-9ded-4f57-9e3b-934a25e7ba75',
                employee_full_name: '',
                event_type: 'work-event'
              },
              {
                description: '',
                calendar_type: 'direct_subordinates',
                created_on: '2018-10-11T14:00:00Z',
                end_recurring_period: '2018-10-14T22:00:00Z',
                end: '2018-10-14T14:15:00.000Z',
                title: 'Work Event: xzdfsdfg',
                event_id: 4,
                rule: 'Rule daily params None',
                start: '2018-10-14T14:00:00.000Z',
                employee: '51a155c0-9ded-4f57-9e3b-934a25e7ba75',
                employee_full_name: '',
                event_type: 'work-event'
              },              {
                description: '',
                calendar_type: 'direct_subordinates',
                created_on: '2018-10-23T09:30:00Z',
                end_recurring_period: undefined,
                end: '2018-10-23T14:00:00.000Z',
                title: 'Work Event: Test',
                event_id: 3,
                rule: 'None',
                start: '2018-10-23T09:30:00.000Z',
                employee: '51a155c0-9ded-4f57-9e3b-934a25e7ba75',
                employee_full_name: '',
                event_type: 'work-event'
              },
              {
                description: '',
                color: 'rgba(255, 50, 50,0.50)',
                calendar_type: 'all_subordinates',
                created_on: '2018-10-19T18:00:00Z',
                end_recurring_period: undefined,
                end: '2018-10-19T18:15:00.000Z',
                title: 'Training: Training Event',
                event_id: 10,
                rule: 'None',
                start: '2018-10-19T18:00:00.000Z',
                employee: '51a155c0-9ded-4f57-9e3b-934a25e7ba75',
                employee_full_name: '',
                event_type: 'training'
              },
              {
                description:  '',
                calendar_type: 'all_subordinates',
                created_on: '2018-10-15T18:00:00Z',
                end_recurring_period: undefined,
                end: '2018-10-15T18:15:00.000Z',
                title: 'Business Travel: Travel Test',
                event_id: 6,
                rule: 'None',
                start: '2018-10-15T18:00:00.000Z',
                employee: '51a155c0-9ded-4f57-9e3b-934a25e7ba75',
                employee_full_name: '',
                event_type: 'business-travel'
              },
              {
                description: '',
                calendar_type: 'all_subordinates',
                created_on: '2018-10-24T14:00:00Z',
                end_recurring_period: '2018-10-24T22:00:00Z',
                end: '2018-10-24T18:15:00.000Z',
                title: 'Custom Other: testing Custom Other',
                event_id: 5,
                rule: 'Rule daily params None',
                start: '2018-10-24T14:00:00.000Z',
                employee: '51a155c0-9ded-4f57-9e3b-934a25e7ba75',
                employee_full_name: '',
                event_type: 'other'
            }
        ];
        
        return calenderObjArr;
    }

    public updateEventFilters(filters: any): any {
        // replace with call to server
    }
}


angular.module('beneple.calendar').service('Calendar', CalendarService);



// WEBPACK FOOTER //
// ./frontend/scripts/calendar/services/calendar.service.ts